import { InlineComposer, type ComposerDrawerPayload, type ComposerMode } from '../shared/timeline/InlineComposer';
import { useLeadComposerSaves } from './useLeadComposerSaves';

export interface LeadComposerHostProps {
  leadId: string;
  pipelineContext?: string;
  onSaved: () => void | Promise<void>;
  onOpenDrawer: (mode: ComposerMode, payload: ComposerDrawerPayload) => void;
}

/**
 * Host del composer inline nella cronologia di un lead o cliente.
 *
 * Esiste per una ragione precisa (fix round 1, I2): le regole degli hook vietano di chiamare
 * `useLeadComposerSaves` in modo condizionale, ma montarlo sempre dentro `LeadNotesSection`
 * significherebbe una seconda sottoscrizione al calendar store (via
 * `useActivitySave` → `useGoogleCalendar`/`useMicrosoftCalendar`) su OGNI schermata che monta
 * la sezione, composer o no — modale note e tab commerciale del progetto compresi. Isolando
 * hook e render qui, il componente viene montato SOLO dove il composer serve davvero.
 */
export function LeadComposerHost({ leadId, pipelineContext, onSaved, onOpenDrawer }: LeadComposerHostProps) {
  const saves = useLeadComposerSaves({ leadId, pipelineContext });

  return (
    <InlineComposer
      onSaveNote={async (html) => {
        await saves.saveNote(html);
        await onSaved();
      }}
      onSaveActivity={async (input) => {
        await saves.saveActivity(input);
        await onSaved();
      }}
      onOpenDrawer={onOpenDrawer}
    />
  );
}

export default LeadComposerHost;
